






import { Component, Vue } from 'vue-property-decorator';
import posed from 'vue-pose';

import WidgetPreviewBox from '@/componentsV2/organisms/WidgetPreviewBox/WidgetPreviewBox.vue';

import { baseAnimations } from '@/views/Onboarding/helpers';
import { IWidgetSettingsFormData } from '@/models/Widget/settings';

@Component({
  components: {
    Container: posed.div(baseAnimations()),
    WidgetPreviewBox
  }
})
export default class LoyaltyWidgetConfigIlustra extends Vue {
  get widgetConfigProps() {
    return this.$store.getters[
      'businessOnboarding/getLoyaltyWidgetForm'
    ] as IWidgetSettingsFormData;
  }

  get device() {
    return this.$store.getters['businessOnboarding/getLoyaltyWidgetForm']
      .device;
  }
}
